import axios from 'axios';
import http from '@/services/http';
import { getOrderId } from '@/utils/getOrderId';

let cancelCourierLocationSrc = null;

export default {
  namespaced: true,
  state: {
    editedRouteTask: [],
    editedRouteTaskInfo: null,
    /**
     * courier,
     * geo_location
     */
    courierLocation: null,
  },
  mutations: {
    SET_EDITED_ROUTE_TASK(state, editedRouteTask) {
      state.editedRouteTask = editedRouteTask;
    },
    SET_EDITED_ROUTE_TASK_INFO(state, editedRouteTaskInfo) {
      state.editedRouteTaskInfo = editedRouteTaskInfo;
    },
    SET_COURIER_LOCATION(state, courierLocation) {
      state.courierLocation = courierLocation;
    },
  },
  actions: {
    async createRouteTask(
      { state, commit, rootState },
      { allowedByFootCourier }
    ) {
      if (state.editedRouteTask.length) {
        const manufactureId = rootState.manufactures.selectedManufacture.id;
        const orderIds = state.editedRouteTask.map((o) => getOrderId(o));
        const res = await http.post(
          `manufacture/${manufactureId}/route_task/`,
          {
            orders_ids: orderIds,
            allowed_by_foot_courier: allowedByFootCourier,
            is_auto: true,
          }
        );
        commit(
          'orders/SET_ROUTE_TASK',
          {
            orderIds,
            routeTaskId: res.route_task_id,
            allowedByFootCourier,
          },
          { root: true }
        );
        commit('SET_EDITED_ROUTE_TASK_INFO', {
          courier: null,
          approved_by_admin: true,
          allowed_by_foot_courier: allowedByFootCourier,
          route_task_id: res.route_task_id,
          changed: false,
        });
        return res;
      }
    },
    async updateRouteTask(
      { state, commit, rootState },
      { allowedByFootCourier }
    ) {
      const manufactureId = rootState.manufactures.selectedManufacture.id;
      const orderIds = state.editedRouteTask.map((o) => getOrderId(o));
      await http.patch(
        `manufacture/${manufactureId}/route_task/${state.editedRouteTaskInfo.route_task_id}`,
        {
          orders_ids: orderIds,
          allowed_by_foot_courier: allowedByFootCourier,
        }
      );
      const updateData = {
        orderIds,
        routeTaskId: state.editedRouteTaskInfo.route_task_id,
        allowedByFootCourier,
      };
      commit('orders/SET_ROUTE_TASK', updateData, { root: true });
      commit('regionOrders/SET_ROUTE_TASK', updateData, { root: true });
      commit('SET_EDITED_ROUTE_TASK_INFO', {
        ...state.editedRouteTaskInfo,
        changed: false,
      });
    },
    async removeRouteTask({ state, commit, rootState, rootGetters }, ordersData = null) {
      const manufactureId = rootState.manufactures.selectedManufacture.id;
      const routeTaskId = state.editedRouteTaskInfo.route_task_id;

      let config = {};
      const isAutoRouteTaskActive = rootGetters['logistics/isAutoRouteTaskActive'];
      
      
      if (state.editedRouteTaskInfo.is_auto && isAutoRouteTaskActive) {
        config = {
          data: ordersData,
          v3: true,
        };
      }

      const res = await http.delete(
        `manufacture/${manufactureId}/route_task/${routeTaskId}`,
        config
      );

      if (!state.editedRouteTaskInfo.courier) {
        const orderIds = state.editedRouteTask.map((o) => getOrderId(o));
        if (routeTaskId) {
          commit('orders/UNSET_ROUTE_TASK', orderIds, { root: true });
          commit('regionOrders/UNSET_ROUTE_TASK', orderIds, { root: true });
        }
        commit('SET_EDITED_ROUTE_TASK', []);
        commit('SET_EDITED_ROUTE_TASK_INFO', null);
      }

      return res;
    },
    async getRouteTaskById({ commit }, id) {
      commit('pageLoader/SET_LOADING', true, { root: true });
      try {
        const res = await http.get(`route_task/${id}`);
        commit('SET_EDITED_ROUTE_TASK', res.orders);
        const routeTaskInfo = {
          ...res,
          changed: false,
        };
        delete routeTaskInfo.orders;
        commit('SET_EDITED_ROUTE_TASK_INFO', routeTaskInfo);
        commit('pageLoader/SET_LOADING', false, { root: true });
      } catch (e) {
        commit('pageLoader/SET_LOADING', false, { root: true });
        throw e;
      }
    },
    async getCourierLocation({ commit, rootState }, id) {
      const manufactureId = rootState.manufactures.selectedManufacture.id;
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      cancelCourierLocationSrc = source;
      const res = await http.get(
        `manufacture/${manufactureId}/route_task/${id}/geo_location`,
        {
          cancelToken: source.token,
        }
      );
      commit('SET_COURIER_LOCATION', {
        courier: res.courier,
        geo_location: res.geo_location,
      });
    },
    cancelCourierLocation() {
      if (cancelCourierLocationSrc) {
        cancelCourierLocationSrc.cancel();
      }
    },
  },
};
